<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="库存日志"></pageTitle>
    <basicList :config="basicListconfig" @search="searchEvent">
      <template v-slot:inventoryChanges="row">
        <div class="inventoryChanges">
          <span> {{ row.row.shop_stock_before }} </span>
          <span> {{ row.row.shop_stock_after }} </span>
        </div>
      </template>
      <template v-slot:changeInAveragePrice="row">
        <div class="inventoryChanges">
          <span> {{ row.row.avg_price_before }} </span>
          <span> {{ row.row.avg_price_after }} </span>
        </div>
      </template>
      <template v-slot:order_no="row">
        <el-link type="primary" @click="purchaseOrder(row.row)">{{
          row.row.order_no
        }}</el-link>
      </template>
    </basicList>
    <previewComponents
      @close="closeView"
      :acceptedParameters="previewParams"
      @refresh="refresh"
    ></previewComponents>
  </div>
</template>

<script>
const defaultParameters = {
  page: 1,
  limit: 10,
};
import { mapGetters } from "vuex";
import { getListByRe } from "@/api/pendingReplenishmentOrder";
import { getshoplist } from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
import {
  orderBuyGetOne,
  orderMoveDetail,
  getShopStocks,
} from "@/api/purchasing";
import { orderSellGetOne } from "@/api/sale";
export default {
  name: "inventoryLogs",
  components: {
    previewComponents: () => import("@/components/previewComponents"),
  },
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,
      // 列表组件参数
      basicListconfig: {
        loading: false,
        operation: false,
        search: [
          {
            label: "门店",
            type: "select",
            options: [],
            key: "shop_id",
            value: "",
          },
          {
            label: "操作人/品名/内容",
            type: "input",
            key: "body",
          },
          {
            label: "",
            type: "daterange",
            key: "create_time",
          },
        ],
        data: [],
        column: [
          {
            label: "类型",
            prop: "type",
            width: 100,
          },
          {
            label: "时间",
            prop: "create_time",
            width: 180,
          },

          {
            label: "门店",
            prop: "shop_name",
            width: 150,
          },
          {
            label: "商品编号",
            prop: "code",
            width: 200,
          },
          {
            label: "商品名称",
            prop: "item_name",
            width: 300,
          },
          {
            label: "数量",
            prop: "shop_stock_change",
            width: 120,
          },
          {
            label: "库存变化",
            prop: "inventoryChanges",
            align: "center",
            slot: true,
            width: 200,
          },
          {
            label: "价格",
            prop: "input_price",
            width: 120,
          },
          {
            label: "均价变化",
            prop: "changeInAveragePrice",
            slot: true,
            align: "center",
            width: 200,
          },
          {
            label: "单号",
            prop: "order_no",
            slot: true,

            width: 240,
          },
          {
            label: "操作人",
            prop: "real_name",
            width: 150,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      previewParams: {
        key: new Date().getTime(),
        visible: false,
        type: "purchaseOrder",
        code: "",
        viewObj: [],
      },
      temporaryRowData: {},
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.dataSources();
    this.getlist();
  },
  methods: {
    purchaseOrder(row) {
      this.temporaryRowData = row;
      this.previewParams.code = row.order_no;
      if (row.type == "销售") {
        orderSellGetOne({ form_sn: row.order_no }).then((res) => {
          if (res.code == 1) {
            let payData = res.$pay_list.map((item) => {
              item.pay_price = this.$money(item.pay_price);
              item.all_price = this.$money(item.all_price);
              item.last_price = this.$money(item.last_price);
              return item;
            });
            let item_way = res.item_way.map((item) => {
              if (item.pics) item.pics = item.pics.split(",");
              return item;
            });
            let data = res.$order_list.map((item) => {
              item.name =
                item.item_info.name +
                "(1*" +
                item.item_info.in_package_num +
                ")(" +
                item.item_info.item_number +
                ")";
              item.freeze_num = item.item_info.freeze_num;
              item.price_distribution = this.$money(item.price_distribution);
              item.item_stock_single = item.item_info.item_stock_single;
              item.item_stock_package = item.item_info.item_stock_package;
              item.total_money = this.$money(item.total_money);
              item.algorithm =
                item.price_distribution +
                "*" +
                "(" +
                item.single_num +
                "+" +
                item.package_num +
                "*" +
                item.item_info.in_package_num +
                ")" +
                "=" +
                item.total_money;
              item.total = item.num;
              //   Number(item.single_num) +
              //   Number(item.package_num) * Number(item.item_info.in_package_num);
              return item;
            });
            this.previewParams.viewObj = [
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "客户",
                    value: res.order_info.customer_name,
                  },
                  {
                    label: "销售门店",
                    value: res.order_info.shop_name,
                  },
                  {
                    label: "业务员",
                    value: res.order_info.customer_user_name,
                  },
                  {
                    label: "制单人",
                    value: res.order_info.user_name,
                  },
                ],
              },
              {
                title: "销售明细",
                type: "array",
                value: data,
                column: [
                  {
                    label: "商品名称",
                    prop: "name",
                    width: 500,
                  },
                  {
                    label: "销售单价",
                    prop: "price_distribution",
                  },

                  {
                    label: "销售总量",
                    prop: "total",
                    align: "center",
                    // children: [
                    //   {
                    //     label: "散",
                    //     prop: "single_num",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "箱",
                    //     prop: "package_num",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "总",
                    //     prop: "total",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    // ],
                  },
                  {
                    label: "小计金额",
                    prop: "total_money",
                    align: "center",
                    // children: [
                    //   {
                    //     label: "金额",
                    //     prop: "total_money",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "算法",
                    //     prop: "algorithm",
                    //     width: 200,
                    //     align: "center",
                    //   },
                    // ],
                  },
                ],
              },
              {
                title: "销售金额",
                type: "object",
                value: [
                  {
                    label: "商品金额",
                    value: this.$money(res.order_info.item_money),
                  },
                  {
                    label: "运费收入",
                    value: this.$money(res.order_info.trans_money),
                  },
                  {
                    label: "订单总金额",
                    value: this.$money(res.order_info.total_money),
                  },
                  {
                    label: "总数量",
                    value: res.order_info.num,
                  },
                  {
                    label: "运费支出",
                    value: this.$money(res.order_info.trans_money_self),
                  },
                  {
                    label: "余额抵扣",
                    value: this.$money(res.order_info.pre_money),
                  },
                  {
                    label: "净毛利",
                    value: this.$money(
                      Number(res.order_info.real_profit_money)
                    ),
                  },
                  {
                    label: "应收总金额",
                    value: this.$money(
                      Number(res.order_info.total_money) -
                        Number(res.order_info.pre_money)
                    ),
                  },
                ],
              },
              {
                title: "收款信息",
                type: "array",
                value: payData,
                column: [
                  {
                    label: "收款账户",
                    prop: "account_name",
                  },
                  {
                    label: "收款",
                    prop: "all_price",
                  },
                  {
                    label: "结款",
                    prop: "pay_price",
                  },
                  {
                    label: "余款",
                    prop: "last_price",
                  },
                  {
                    label: "时间",
                    prop: "create_time",
                  },
                  {
                    label: "类型",
                    prop: "pay_type",
                  },
                  {
                    label: "操作",
                    prop: "operation",
                  },
                ],
              },
              {
                title: "收款信息",
                type: "object",
                value: [
                  {
                    label: "已收金额",
                    value: this.$money(res.order_info.payed_money),
                  },
                  {
                    label: "未收金额",
                    value: this.$money(res.order_info.last_money),
                  },
                ],
              },
              {
                title: "订单备注",
                type: "object",
                value: [
                  {
                    label: "公司名称",
                    value: res.order_info.comp_remark,
                  },
                  {
                    label: "其它备注",
                    value: res.order_info.remark,
                  },
                ],
              },
              {
                title: "溯源信息",
                type: "array",
                value: item_way,
                column: [
                  {
                    label: "ID",
                    prop: "id",
                    width: 80,
                  },
                  {
                    label: "溯源码",
                    prop: "code_value",
                  },
                  // {
                  //   label: "品名",
                  //   prop: "item_name",
                  // },
                  // {
                  //   label: "会员号",
                  //   prop: "customer_id",
                  // },
                  {
                    label: "操作人",
                    prop: "user_name",
                    width: 100,
                  },
                  {
                    label: "溯源照片",
                    prop: "pics",
                    width: 200,
                  },
                  {
                    label: "更新时间",
                    prop: "update_time",
                    width: 100,
                  },
                ],
              },
            ];

            this.previewParams.key = new Date().getTime();
            this.previewParams.visible = true;
            this.previewParams.type = "sale";
          } else {
            this.$message.error("获取详情失败");
          }
        });
      } else if (row.type == "调货") {
        orderMoveDetail({
          form_sn: row.order_no,
          comp_id: JSON.parse(getRoles()).comp_id,
        }).then((res) => {
          if (res.code == 1) {
            let order_info = res.data[0];
            let item_ids = [];
            let data = res.data[0].order_list.map((item) => {
              item_ids.push(item.item_id);
              item.name =
                item.item_info.name +
                "(1*" +
                item.item_info.in_package_num +
                ")(" +
                item.item_info.item_number +
                ")";
              item.item_info.value = item.item_id;
              item.avg_price = this.$money(item.avg_price);
              item.total_money = this.$money(item.total_money);
              delete item.item_info.item_stock_package;
              item.inventoryBox = item.item_stock_package_out;
              delete item.item_info.item_stock_single;
              item.inventoryDispersion = item.item_stock_single_out;
              item.in_package_num = item.item_info.in_package_num;
              item.num = item.num;
              item.freezeInventory = item.freeze_num;
              item.totalInventory =
                Number(item.inventoryDispersion) +
                Number(item.inventoryBox) * Number(item.in_package_num);
              item.totalPurchaseQuantity =
                Number(item.item_stock_single) +
                Number(item.item_stock_package) * Number(item.in_package_num);
              item.productOptions = [item.item_info];
              return item;
            });
            getShopStocks({
              comp_id: JSON.parse(getRoles()).comp_id,
              shop_id: order_info.in_shop_id,
              item_id: item_ids.join(","),
            }).then((res) => {
              if (res.code == 1) {
                res.data.forEach((in_shop_item) => {
                  for (let i = 0; i < data.length; i++) {
                    let item = data[i];
                    if (item.item_id == in_shop_item.item_id) {
                      this.$set(data[i], "totalInventory_in", in_shop_item.num);
                      this.$set(
                        data[i],
                        "inventoryBox_in",
                        in_shop_item.item_stock_package
                      );
                      this.$set(
                        data[i],
                        "inventoryDispersion_in",
                        in_shop_item.item_stock_single
                      );
                    }
                  }
                });
              } else {
                this.$message.error(
                  res.data.msg || "获取该产品调入门店库存失败"
                );
              }
            });

            this.previewParams.viewObj = [
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "调出门店",
                    value: order_info.out_shop_name,
                  },
                  {
                    label: "调入门店",
                    value: order_info.in_shop_name,
                  },
                  {
                    label: "制单人",
                    value: order_info.user_name,
                  },
                  {
                    label: "出库人",
                    value: order_info.out_user_name,
                  },
                  {
                    label: "入库人",
                    value: order_info.in_user_name,
                  },
                  {
                    label: "备注",
                    value: order_info.remark,
                  },
                ],
              },
              {
                title: "调货明细",
                type: "array",
                value: data,
                column: [
                  {
                    label: "商品名称",
                    prop: "name",
                  },
                  {
                    label: "成本价",
                    prop: "avg_price",
                    width: 100,
                  },
                  {
                    label: "数量",
                    prop: "totalPurchaseQuantity",
                    width: 120,
                    align: "center",
                  },
                  {
                    label: "小计",
                    prop: "total_money",
                    width: 100,
                  },
                ],
              },
              {
                title: "调货金额",
                type: "object",
                value: [
                  {
                    label: "商品金额",
                    value: this.$money(order_info.item_money),
                  },
                  {
                    label: "运费金额",
                    value: this.$money(order_info.trans_money),
                  },
                  {
                    label: "调货总金额",
                    value: this.$money(order_info.total_money),
                  },
                ],
              },
            ];
            this.previewParams.key = new Date().getTime();
            this.previewParams.visible = true;
          }
        });
      } else {
        orderBuyGetOne({ form_sn: row.order_no }).then((res) => {
          if (res.code == 1) {
            let payData = res.$pay_list.map((item) => {
              item.pay_price = this.$money(item.pay_price);
              item.all_price = this.$money(item.all_price);
              item.last_price = this.$money(item.last_price);
              return item;
            });
            let item_way = res.item_way.map((item) => {
              if (item.pics) item.pics = item.pics.split(",");
              return item;
            });
            let data = res.$order_list.map((item) => {
              item.name =
                item.item_info.name +
                "(1*" +
                item.item_info.in_package_num +
                ")";
              item.price_distribution = this.$money(item.price_distribution);
              item.need_item_stock_single = item.single_num;
              item.need_item_stock_package = item.package_num;
              item.total_money = this.$money(item.total_money);
              item.price_oneBox = (
                Number(item.price_distribution) * Number(item.in_package_num)
              ).toFixed(2);
              item.need_item_stock_total = (
                Number(item.need_item_stock_single) +
                Number(item.need_item_stock_package) *
                  Number(item.in_package_num)
              ).toFixed(0);
              item.algorithm =
                item.price_distribution +
                "*" +
                "(" +
                item.need_item_stock_single +
                "+" +
                item.need_item_stock_package +
                "*" +
                item.in_package_num +
                ") = " +
                item.total_money;
              return item;
            });
            this.previewParams.viewObj = [
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "供应商",
                    value: res.order_info.supplier_name,
                  },
                  {
                    label: "采购门店",
                    value: res.order_info.shop_name,
                  },
                  {
                    label: "采购人",
                    value: res.order_info.customer_name,
                  },
                  {
                    label: "制单人",
                    value: res.order_info.user_name,
                  },
                  {
                    label: "备注",
                    value: res.order_info.remark,
                  },
                ],
              },
              {
                title: "采购明细",
                type: "array",
                value: data,
                column: [
                  {
                    label: "商品名称",
                    prop: "name",
                  },
                  {
                    label: "单价",
                    prop: "price_distribution",
                  },
                  {
                    label: "采购数量",
                    prop: "num",
                    align: "center",
                  },
                  {
                    label: "小计",
                    prop: "total_money",
                    width: 200,
                  },
                ],
              },
              {
                title: "采购金额",
                type: "object",
                value: [
                  {
                    label: "商品金额",
                    value: this.$money(res.order_info.item_money),
                  },
                  {
                    label: "运费金额",
                    value: this.$money(res.order_info.trans_money),
                  },
                  {
                    label: "订单总金额",
                    value: this.$money(res.order_info.total_money),
                  },
                  {
                    label: "余额抵扣",
                    value: this.$money(res.order_info.pre_money),
                  },
                  {
                    label: "应付总金额",
                    value: this.$money(
                      Number(res.order_info.total_money) -
                        Number(res.order_info.pre_money)
                    ),
                  },
                ],
              },
              {
                title: "付款信息",
                type: "array",
                value: payData,
                column: [
                  {
                    label: "付款账户",
                    prop: "account_name",
                  },
                  {
                    label: "付款",
                    prop: "all_price",
                  },
                  {
                    label: "结款",
                    prop: "pay_price",
                  },
                  {
                    label: "余款",
                    prop: "last_price",
                  },
                  {
                    label: "时间",
                    prop: "create_time",
                  },
                  {
                    label: "类型",
                    prop: "pay_type",
                  },
                  {
                    label: "操作",
                    prop: "operation",
                  },
                ],
              },
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "已付金额",
                    value: this.$money(res.order_info.payed_money),
                  },
                  {
                    label: "未付金额",
                    value: this.$money(res.order_info.last_money),
                  },
                ],
              },
              {
                title: "溯源信息",
                type: "array",
                value: item_way,
                column: [
                  {
                    label: "ID",
                    prop: "id",
                    width: 80,
                  },
                  {
                    label: "溯源码",
                    prop: "code_value",
                  },
                  {
                    label: "操作人",
                    prop: "user_name",
                    width: 100,
                  },
                  {
                    label: "溯源照片",
                    prop: "pics",
                    width: 200,
                  },
                  {
                    label: "更新时间",
                    prop: "update_time",
                    width: 100,
                  },
                ],
              },
            ];

            this.previewParams.key = new Date().getTime();
            this.previewParams.visible = true;
          } else {
            this.$message.error("获取详情失败");
          }
        });
      }
      console.log(
        "%c [ row ]-158",
        "font-size:13px; background:pink; color:#bf2c9f;",
        row
      );
    },
    // 关闭查看
    closeView() {
      this.previewParams.key = new Date().getTime();
      this.previewParams.visible = false;
    },
    refresh() {
      this.preview(this.temporaryRowData);
    },
    dataSources() {
      getshoplist({ status: 0, comp_id: JSON.parse(getRoles()).comp_id }).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                console.log(
                  "%c [  ]-142",
                  "font-size:13px; background:pink; color:#bf2c9f;"
                );
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
              return item;
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          if (Array.isArray(data[key])) {
            if (data[key].length == 0) {
              delete this.basicListconfig.searchParameters.start_time;
              delete this.basicListconfig.searchParameters.end_time;
            } else {
              this.basicListconfig.searchParameters.start_time = data[key][0];
              this.basicListconfig.searchParameters.end_time = data[key][1];
            }
          }
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters.comp_id = this.compId;
      getListByRe(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data.items;
          this.basicListconfig.total = res.data.count;
        } else if (res.code == 0) {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style  scoped>
.inventoryChanges {
  display: flex;
}
.inventoryChanges span {
  display: block;
  width: 50%;
}
.inventoryChanges span:last-child {
  border-left: 1px solid #ebeef5;
}
</style>



// WEBPACK FOOTER //
// src/views/inventoryLogs/index.vue